import React from 'react';
import styles from './index.css';

const NoData = () => {
    return (
        <div className={styles.wrap}>
            <div className={styles.placeHolder} />
            <div className={styles.text}>暂无评论</div>
        </div>
    );
};

export default NoData;
